<template lang="jade">
  div.Dropdown(v-bind:class="{'Dropdown--disabled': disabled}"
               ":skin"="skins.inputs")
    div.Dropdown__field(@click="toggle")
      slot(name="Dropdown__field")
      span.Dropdown__indicator(v-bind:class="{'Dropdown__indicator--open': open}"
                               v-show="!disabled")
    ul.Dropdown__menu(v-show="open")
      li.Dropdown__item(v-for="option in options"
                        v-bind:class="{'Dropdown__item--active':active === $index}"
                        @click="callback(option)")
        component(v-if="option.component"
                  ":is"="option.component"
                  ":fdata"="option")
        span(v-else) {{ option.label }}
</template>

<script>
  import { skins } from 'src/vuex/getters'

  export default {
    props: {
      options: {
        type: Array,
        required: true
      },
      callback: {
        type: Function,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      active: {
        type: Number
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    vuex: {
      getters: {
        skins
      }
    },

    methods: {
      toggle () {
        if (this.disabled) return false
        this.open = !this.open
      }
    }
  }
</script>



// WEBPACK FOOTER //
// dropdown.vue?a54b01b8